import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as licenseService from '../../services/licenseService';

export const fetchLicenseStatus = createAsyncThunk(
  'license/fetchStatus',
  async (_, { rejectWithValue }) => {
    try {
      const res = await licenseService.getLicenseStatus();
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch license status');
    }
  }
);

export const retryLicense = createAsyncThunk(
  'license/retry',
  async (_, { rejectWithValue }) => {
    try {
      const res = await licenseService.retryLicense();
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to contact license server');
    }
  }
);

const initialState = {
  state: 'LOADING',
  reason: null,
  message: null,
  lastCheckedAt: null,
  lastValidCheckin: null,
  graceExpiresAt: null,
  graceHours: 48,
  loading: false,
  error: null,
};

const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicenseStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLicenseStatus.fulfilled, (state, action) => {
        state.loading = false;
        Object.assign(state, action.payload);
      })
      .addCase(fetchLicenseStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.state = 'UNREACHABLE';
      })
      .addCase(retryLicense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retryLicense.fulfilled, (state, action) => {
        state.loading = false;
        Object.assign(state, action.payload);
      })
      .addCase(retryLicense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = licenseSlice.actions;
export default licenseSlice.reducer;
